import { Component } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-idea-tower',
  standalone: false,
  templateUrl: './idea-tower.component.html',
  styleUrl: './idea-tower.component.scss'
})
export class IdeaTowerComponent {
  thisStepCount: number = 0;
  totalStepCount: number = 0;
  progress: number = 0;
  nextBtnDisabledStatus: boolean = true;
  stepId: any;
  streamId: any;

  stream: any;
  step: any

  constructor(
    private appData: AppdataService,
    private route: ActivatedRoute
  ) {
    route.queryParams.subscribe(async (params) => {
      this.stepId = await params['stepId'];
      this.streamId = await params['streamId'];
    });

    appData.tracks.subscribe(async (data) => {
      for await (const track of data) {
        for await (const stream of track.streams) {
          if (stream.id === this.streamId) {
            this.stream = stream;
            this.step = await stream.steps.find((step: any) => step.id === this.stepId);

            this.totalStepCount = stream.steps.length;
            this.thisStepCount = this.step.orderNr

            let pro = this.thisStepCount / this.totalStepCount;
            this.progress = pro * 100;

            console.log('Stream:', this.stream);
            console.log('Step:', this.step);

          }
        }
      }
    });
  }
}
